import script from "./InstructionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstructionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./InstructionsPage.vue?vue&type=style&index=0&id=a49b2eb0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a49b2eb0"]])

export default __exports__